import { createApiService } from "./baseApi";

/**
 * Dashboard API Service
 * Uses centralized error handling from baseApi
 * Error handling (401 logout, toast notifications) is automatic
 */
export const dashboardApi = createApiService("dashboardApi", (builder) => ({
   dashboardData: builder.mutation({
      query: (_payload) => ({
         method: "GET",
         url: `dashboard`,
      }),
      transformResponse: (result) => result,
      // Error handling is now centralized in baseApi
      // No need for onQueryStarted error handling
   }),

   venderHitCountData: builder.mutation({
      query: (payload) => ({
         method: "GET",
         url: `venderHitCounts?filterType=${payload?.filterType}`,
      }),
      transformResponse: (result) => result,
      // Error handling is now centralized in baseApi
      // No need for onQueryStarted error handling
   }),

   SubsExpData: builder.mutation({
      query: (_payload) => ({
         method: "GET",
         url: `subscriptionExpiring`,
      }),
      transformResponse: (result) => result,
      // Error handling is now centralized in baseApi
      // No need for onQueryStarted error handling
   }),
}));

// Export hooks - these are automatically generated by RTK Query
export const {
   useDashboardDataMutation,
   useVenderHitCountDataMutation,
   useSubsExpDataMutation
} = dashboardApi;
